export default __webpack_public_path__ + "static/media/statistics.3c55b2e3.jpg";